import React, { useState } from "react";
import { FaTimes, FaMinus, FaExpand } from "react-icons/fa";
import Iva from "./Iva";
import "./IvaWidget.css";
import "../FunctionalComponents/Floaticon.css";

const IvaWidget = ({ isOpen, setIsOpen }) => {
  const [minimized, setMinimized] = useState(false);
  const [maximized, setMaximized] = useState(false);
  const [messages, setMessages] = useState([]);

  return (
    <>
      {/* Floating launcher */}
      {!isOpen && (
        <div className="float-icon-box" onClick={() => setIsOpen(true)}>
          <div className="float-icon-img-box">
            <img
              src={`${process.env.PUBLIC_URL}/Assets/float-icon-new.gif`}
              alt="askiva-icon"
              className="askiva-float-icon"
            />
          </div>
          <div className="float-icon-img-box">
            <img
              src={`${process.env.PUBLIC_URL}/Assets/float-icon-new-text.png`}
              alt="askiva-text"
              className="askiva-float-icon-text"
            />
          </div>
        </div>
      )}

      {isOpen && (
        <div
          className={`iva-popup ${minimized ? "minimized" : ""} ${
            maximized ? "maximized" : ""
          }`}
        >
          {/* HEADER */}
          <div className="iva-header">
            <img
              src="./Assets/askivabot.png"
              alt="Bot"
              className="iva-bot-icon"
            />

            <div className="iva-title-wrapper">
              <span className="iva-title">IVA</span>
              <span className="iva-powered">Powered by Genius Tutor</span>
            </div>

            <div className="iva-actions">
              <FaMinus
                title="Minimize"
                onClick={() => {
                  setMinimized(v => !v);
                  setMaximized(false);
                }}
              />
              <FaExpand
                title="Maximize"
                onClick={() => {
                  setMaximized(v => !v);
                  setMinimized(false);
                }}
              />
              <FaTimes
                title="Close"
                onClick={() => {
                  setIsOpen(false);
                  setMinimized(false);
                  setMaximized(false);
                }}
              />
            </div>
          </div>

          {/* BODY */}
          {!minimized && (
            <div className="iva-body">
              <Iva messages={messages} setMessages={setMessages} />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default IvaWidget;
